import Vue from 'vue';
import Router from 'vue-router';

//Main
import Layout from '@/components/Layout/Layout';
import Dashboard from '@/pages/Dashboard/Dashboard';
import ChatXC from '@/pages/ChatXC/ChatXC';
import Directory from '@/pages/Directory/Directory';
import Error from '@/pages/Error/Error';
import Login from '@/pages/Login/Login';
import PrivacyPolicy from '@/pages/PrivacyPolicy/Policy';
import ResetPassword from '@/pages/ResetPassword/ResetPassword';

import PrintBill from '@/pages/Print/PrintBill';
import PrintGLReportIS from '@/pages/Print/PrintGLReportIS';
import PrintGLReportBS from '@/pages/Print/PrintGLReportBS';
import PrintGLReportGL from '@/pages/Print/PrintGLReportGL';
import PrintInvoice from '@/pages/Print/PrintInvoice';
import PrintPayStatement from '@/pages/Print/PrintPayStatement';
import PrintReport from '@/pages/Print/PrintReport';
import PrintSalesOrder from '@/pages/Print/PrintSalesOrder';

import PrintCustomerOpenInvoice from '@/pages/Print/PrintCustomerOpenInvoice';
import PrintSalesRepOpenOrder from '@/pages/Print/PrintSalesRepOpenOrder';
//Account
import AccountList from '@/pages/Account/List/List';
import AccountAdd from '@/pages/Account/Add/Add';
import AccountEdit from '@/pages/Account/Edit/Edit';
//Alert
import AlertList from '@/pages/Alert/List/List';
import AlertAdd from '@/pages/Alert/Add/Add';
import AlertEdit from '@/pages/Alert/Edit/Edit';
//Asset
import AssetList from '@/pages/Asset/List/List';
import AssetAdd from '@/pages/Asset/Add/Add';
import AssetEdit from '@/pages/Asset/Edit/Edit';
//Bank Account
import BankAccountList from '@/pages/BankAccount/List/List';
import BankAccountAdd from '@/pages/BankAccount/Add/Add';
import BankAccountEdit from '@/pages/BankAccount/Edit/Edit';
import BankAccountView from '@/pages/BankAccount/View/View';
//Batch Deposit
import BatchDepositAdd from '@/pages/BatchDeposit/Add/Add';
import BatchDepositEdit from '@/pages/BatchDeposit/Edit/Edit';
import BatchDepositList from '@/pages/BatchDeposit/List/List';
import BatchDepositPrint from '@/pages/BatchDeposit/Print/Print';
//Batch Payment
import BatchPaymentAdd from '@/pages/BatchPayment/Add/Add';
import BatchPaymentEdit from '@/pages/BatchPayment/Edit/Edit';
import BatchPaymentList from '@/pages/BatchPayment/List/List';
import BatchPaymentPrint from '@/pages/BatchPayment/Print/Print';
//Bill
import BillList from '@/pages/Bill/List/List';
import BillAdd from '@/pages/Bill/Add/Add';
import BillEdit from '@/pages/Bill/Edit/Edit';
import BillPrint from '@/pages/Bill/Print/Print';
import BillView from '@/pages/Bill/View/View';
//Bill of Material
import BillMaterialList from '@/pages/BillMaterial/List/List';
import BillMaterialAdd from '@/pages/BillMaterial/Add/Add';
import BillMaterialEdit from '@/pages/BillMaterial/Edit/Edit';
import BillMaterialPrint from '@/pages/BillMaterial/Print/Print';
import BillMaterialView from '@/pages/BillMaterial/View/View';
//Brand
import BrandList from '@/pages/Brand/List/List';
import BrandAdd from '@/pages/Brand/Add/Add';
import BrandEdit from '@/pages/Brand/Edit/Edit';
//City
import CityList from '@/pages/City/List/List';
import CityAdd from '@/pages/City/Add/Add';
import CityEdit from '@/pages/City/Edit/Edit';
//Claim
import ClaimAdmList from '@/pages/Claim/Adm/List/List';
import ClaimHrmList from '@/pages/Claim/Hrm/List/List';
import ClaimAdd from '@/pages/Claim/Add/Add';
import ClaimEdit from '@/pages/Claim/Edit/Edit';
import ClaimView from '@/pages/Claim/View/View';
import ClaimPrint from '@/pages/Claim/Print/Print';
//Company
import CompanyList from '@/pages/Company/List/List';
import CompanyAdd from '@/pages/Company/Add/Add';
import CompanyEdit from '@/pages/Company/Edit/Edit';
//Company Policy
import CompanyPolicyLayout from '@/pages/CompanyPolicy/components/Layout/DocLayout';
import CompanyPolicyView from '@/pages/CompanyPolicy/pages/View/View';
//Country
import CountryList from '@/pages/Country/List/List';
import CountryAdd from '@/pages/Country/Add/Add';
import CountryEdit from '@/pages/Country/Edit/Edit';
//Creative Project
import CreativeProjectTeamList from '@/pages/CreativeProject/Team/List/List';
import CreativeProjectTeamAssign from '@/pages/CreativeProject/Team/Assign/Edit';
import CreativeProjectTeamFinalize from '@/pages/CreativeProject/Team/Finalize/Edit';
import CreativeProjectResponse from '@/pages/CreativeProject/Response/Edit';
import CreativeProjectList from '@/pages/CreativeProject/List/List';
import CreativeProjectEdit from '@/pages/CreativeProject/Edit/Edit';
import CreativeProjectRequest from '@/pages/CreativeProject/Request/Add';
import CreativeProjectManage from '@/pages/CreativeProject/Manage/View';
//Currency
import CurrencyList from '@/pages/Currency/List/List';
import CurrencyAdd from '@/pages/Currency/Add/Add';
import CurrencyEdit from '@/pages/Currency/Edit/Edit';
//Customer
import CustomerList from '@/pages/Customer/List/List';
import CustomerActiveList from '@/pages/Customer/Active/List/List';
import CustomerAdd from '@/pages/Customer/Add/Add';
import CustomerEdit from '@/pages/Customer/Edit/Edit';
import CustomerView from '@/pages/Customer/View/View';
//Customer Report
import CustomerReportSummaryByTownship from '@/pages/CustomerReport/summarybytownship/List';
import CustomerReportSummaryByUser from '@/pages/CustomerReport/summarybyuser/List';
//Department
import DepartmentList from '@/pages/Department/List/List';
import DepartmentAdd from '@/pages/Department/Add/Add';
import DepartmentEdit from '@/pages/Department/Edit/Edit';
//Deposit
import DepositAdd from '@/pages/Deposit/Add/Add';
import DepositEdit from '@/pages/Deposit/Edit/Edit';
import DepositList from '@/pages/Deposit/List/List';
import DepositPrint from '@/pages/Deposit/Print/Print';
import DepositView from '@/pages/Deposit/View/View';
//District
import DistrictList from '@/pages/District/List/List';
import DistrictAdd from '@/pages/District/Add/Add';
import DistrictEdit from '@/pages/District/Edit/Edit';
//Employee
import EmployeeList from '@/pages/Employee/List/List';
import EmployeeAdd from '@/pages/Employee/Add/Add';
import EmployeeEdit from '@/pages/Employee/Edit/Edit';
import EmployeeCard from '@/pages/Employee/Card/Card';
import EmployeeView from '@/pages/Employee/View/View';
//Employee Face
import EmployeeFaceList from '@/pages/EmployeeFace/List/List';
import EmployeeFaceAdd from '@/pages/EmployeeFace/Add/Add';
import EmployeeFaceEdit from '@/pages/EmployeeFace/Edit/Edit';
//Expense Report
import ExpenseReportByAccount from '@/pages/ExpenseReport/byaccount/List';
import ExpenseReportByChannel from '@/pages/ExpenseReport/bychannel/List';
import ExpenseReportByLocation from '@/pages/ExpenseReport/bylocation/List';

import FinanceReportList from '@/pages/FinanceReport/List/List';
import FinanceReportReceivables from '@/pages/FinanceReport/receivables/List';
import FinanceReportReceivablesAging from '@/pages/FinanceReport/receivables-aging/List';
import FinanceReportPayables from '@/pages/FinanceReport/payables/List';
import FinanceReportPayablesAging from '@/pages/FinanceReport/payables-aging/List';
//Fixed Asset
import FixedAssetList from '@/pages/FixedAsset/List/List';
import FixedAssetAdd from '@/pages/FixedAsset/Add/Add';
import FixedAssetEdit from '@/pages/FixedAsset/Edit/Edit';
//FA Bill
import FABillList from '@/pages/FABill/List/List';
import FABillAdd from '@/pages/FABill/Add/Add';
import FABillEdit from '@/pages/FABill/Edit/Edit';
import FABillPrint from '@/pages/FABill/Print/Print';
import FABillView from '@/pages/FABill/View/View';
//File
import FilePreview from '@/pages/File/Preview/Preview';
//Geolocation
import GeolocationByCustomer from '@/pages/Geolocation/Customer/geolocation';
import GeolocationByCustomerSales from '@/pages/Geolocation/CustomerSales/geolocation';
import GeolocationBySaleVisits from '@/pages/Geolocation/SaleVisits/geolocation';
import GeolocationByUser from '@/pages/Geolocation/User/geolocation';
//GL Journal
import GLJournalList from '@/pages/GLJournal/List/List';
import GLJournalAdd from '@/pages/GLJournal/Add/Add';
import GLJournalEdit from '@/pages/GLJournal/Edit/Edit';
import GLJournalPrint from '@/pages/GLJournal/Print/Print';
import GLJournalView from '@/pages/GLJournal/View/View';
//GL Ledger
import GLLedgerList from '@/pages/GLLedger/List/List';
import GLLedgerAdd from '@/pages/GLLedger/Add/Add';
import GLLedgerEdit from '@/pages/GLLedger/Edit/Edit';
//GL Map
import GLMapList from '@/pages/GLMap/List/List';
import GLMapAdd from '@/pages/GLMap/Add/Add';
import GLMapEdit from '@/pages/GLMap/Edit/Edit';
//GL Post
import GLPostList from '@/pages/GLPost/List/List';
import GLPostAdd from '@/pages/GLPost/Add/Add';
import GLPostEdit from '@/pages/GLPost/Edit/Edit';
import GLPostView from '@/pages/GLPost/View/View';
//GL Report
import GLReportList from '@/pages/GLReport/List/List';
import GLReportIS from '@/pages/GLReport/IS/Print';
import GLReportBS from '@/pages/GLReport/BS/Print';
import GLReportGL from '@/pages/GLReport/GL/Print';

//Holiday
import HolidayList from '@/pages/Holiday/List/List';
import HolidayAdd from '@/pages/Holiday/Add/Add';
import HolidayEdit from '@/pages/Holiday/Edit/Edit';
//Invoice
import InvoiceList from '@/pages/Invoice/List/List';
import InvoiceAdd from '@/pages/Invoice/Add/Add';
import InvoiceEdit from '@/pages/Invoice/Edit/Edit';
import InvoicePrint from '@/pages/Invoice/Print/Print';
import InvoiceView from '@/pages/Invoice/View/View';
//Item
import ItemList from '@/pages/Item/List/List';
import ItemAdd from '@/pages/Item/Add/Add';
import ItemEdit from '@/pages/Item/Edit/Edit';
//ItemCategory
import ItemCategoryList from '@/pages/ItemCategory/List/List';
import ItemCategoryAdd from '@/pages/ItemCategory/Add/Add';
import ItemCategoryEdit from '@/pages/ItemCategory/Edit/Edit';
//ItemGroup
import ItemGroupList from '@/pages/ItemGroup/List/List';
import ItemGroupAdd from '@/pages/ItemGroup/Add/Add';
import ItemGroupEdit from '@/pages/ItemGroup/Edit/Edit';
//ItemSubcategory
import ItemSubcategoryList from '@/pages/ItemSubcategory/List/List';
import ItemSubcategoryAdd from '@/pages/ItemSubcategory/Add/Add';
import ItemSubcategoryEdit from '@/pages/ItemSubcategory/Edit/Edit';
//Inventory Check
import InventoryList from '@/pages/Inventory/List/List';
import InventoryPrint from '@/pages/Inventory/Print/Print';
import InventoryView from '@/pages/Inventory/View/View';
//Inventory Count
import InventoryCountList from '@/pages/InventoryCount/List/List';
import InventoryCountPrint from '@/pages/InventoryCount/Print/Print';
import InventoryCountView from '@/pages/InventoryCount/View/View';
//Inventory Journal
import InventoryJournalList from '@/pages/InventoryJournal/List/List';
import InventoryJournalAdd from '@/pages/InventoryJournal/Add/Add';
import InventoryJournalEdit from '@/pages/InventoryJournal/Edit/Edit';
import InventoryJournalPrint from '@/pages/InventoryJournal/Print/Print';
import InventoryJournalView from '@/pages/InventoryJournal/View/View';
//Invest Fund
import InvestFundList from '@/pages/InvestFund/List/List';
import InvestFundAdd from '@/pages/InvestFund/Add/Add';
import InvestFundEdit from '@/pages/InvestFund/Edit/Edit';
import InvestStockList from '@/pages/InvestStock/List/List';
import InvestStockAdd from '@/pages/InvestStock/Add/Add';
import InvestStockEdit from '@/pages/InvestStock/Edit/Edit';
//InvestJournal
import InvestJournalAdd from '@/pages/InvestJournal/Add/Add';
import InvestJournalEdit from '@/pages/InvestJournal/Edit/Edit';
import InvestJournalList from '@/pages/InvestJournal/List/List';
import InvestJournalPrint from '@/pages/InvestJournal/Print/Print';
import InvestJournalView from '@/pages/InvestJournal/View/View';
//Language
import LanguageList from '@/pages/Language/List/List';
import LanguageAdd from '@/pages/Language/Add/Add';
import LanguageEdit from '@/pages/Language/Edit/Edit';
//Loading Order
import LoadingOrderList from '@/pages/LoadingOrder/List/List';
import LoadingOrderAdd from '@/pages/LoadingOrder/Add/Add';
import LoadingOrderEdit from '@/pages/LoadingOrder/Edit/Edit';
import LoadingOrderPrint from '@/pages/LoadingOrder/Print/Print';
import LoadingOrderView from '@/pages/LoadingOrder/View/View';
//Location
import LocationList from '@/pages/Location/List/List';
import LocationAdd from '@/pages/Location/Add/Add';
import LocationEdit from '@/pages/Location/Edit/Edit';
//Location Tracking
import LocationTrackingList from '@/pages/LocationTracking/List/List';
import LocationTrackingAdd from '@/pages/LocationTracking/Add/Add';
import LocationTrackingEdit from '@/pages/LocationTracking/Edit/Edit';
//Material
import MaterialList from '@/pages/Material/List/List';
import MaterialAdd from '@/pages/Material/Add/Add';
import MaterialEdit from '@/pages/Material/Edit/Edit';
//Marketing Platform
import MarketPlatformList from '@/pages/MarketPlatform/List/List';
import MarketPlatformAdd from '@/pages/MarketPlatform/Add/Add';
import MarketPlatformEdit from '@/pages/MarketPlatform/Edit/Edit';
//Marketing Project
import MarketProjectList from '@/pages/MarketProject/List/List';
import MarketProjectTeamList from '@/pages/MarketProject/Team/List/List';
import MarketProjectAdd from '@/pages/MarketProject/Add/Add';
import MarketProjectEdit from '@/pages/MarketProject/Edit/Edit';
import MarketProjectPrint from '@/pages/MarketProject/Print/Print';
import MarketProjectDigitalManage from '@/pages/MarketProject/Manage/Digital/View';
import MarketProjectTraditionalManage from '@/pages/MarketProject/Manage/Traditional/View';
//Menu
import MenuList from '@/pages/Menu/List/List';
import MenuAdd from '@/pages/Menu/Add/Add';
import MenuEdit from '@/pages/Menu/Edit/Edit';
//My Account
import MyClaimList from '@/pages/My/Claim/List/List';
import MyClaimAdd from '@/pages/My/Claim/Add/Add';
import MyClaimPrint from '@/pages/My/Claim/Print/Print';
import MyReimbursementList from '@/pages/My/Reimbursement/List/List';
import MyRequestList from '@/pages/My/Request/List/List';
import MyRequestAdd from '@/pages/My/Request/Add/Add';
import MyStatementList from '@/pages/My/Statement/List/List';
//Payment
import PaymentAdd from '@/pages/Payment/Add/Add';
import PaymentEdit from '@/pages/Payment/Edit/Edit';
import PaymentList from '@/pages/Payment/List/List';
import PaymentPrint from '@/pages/Payment/Print/Print';
import PaymentView from '@/pages/Payment/View/View';
//Payroll
import PayrollList from '@/pages/Payroll/List/List';
import PayrollAdd from '@/pages/Payroll/Add/Add';
import PayrollEdit from '@/pages/Payroll/Edit/Edit';
import PayrollPrint from '@/pages/Payroll/Print/Print';
import PayrollView from '@/pages/Payroll/View/View';
//Payroll Entry
import PayrollEntryAdd from '@/pages/PayrollEntry/Add/Add';
import PayrollEntryEdit from '@/pages/PayrollEntry/Edit/Edit';
import PayrollEntryList from '@/pages/PayrollEntry/List/List';
//Payroll Recurring
import PayrollRecurringList from '@/pages/PayrollRecurring/List/List';
import PayrollRecurringAdd from '@/pages/PayrollRecurring/Add/Add';
import PayrollRecurringEdit from '@/pages/PayrollRecurring/Edit/Edit';
//Pay Method
import PayMethodList from '@/pages/PayMethod/List/List';
import PayMethodAdd from '@/pages/PayMethod/Add/Add';
import PayMethodEdit from '@/pages/PayMethod/Edit/Edit';
//Pay Statement
import PayStatementList from '@/pages/PayStatement/List/List';
import PayStatementAdd from '@/pages/PayStatement/Add/Add';
import PayStatementEdit from '@/pages/PayStatement/Edit/Edit';
import PayStatementPrint from '@/pages/PayStatement/Print/Print';
import PayStatementDocAuth from '@/pages/Doc/PS/Auth';
import PayStatementDocView from '@/pages/Doc/PS/Print';
//Policy
import PolicyList from '@/pages/Policy/List/List';
import PolicyAdd from '@/pages/Policy/Add/Add';
import PolicyEdit from '@/pages/Policy/Edit/Edit';
import PolicyPrint from '@/pages/Policy/Print/Print';
//Price
import PriceList from '@/pages/Price/List/List';
import PriceAdd from '@/pages/Price/Add/Add';
import PriceEdit from '@/pages/Price/Edit/Edit';
//Pricelist
import PricelistList from '@/pages/PriceList/List/List';
import PricelistAdd from '@/pages/PriceList/Add/Add';
import PricelistEdit from '@/pages/PriceList/Edit/Edit';
import PricelistPrint from '@/pages/PriceList/Print/Print';



//Promotion
import PromotionList from '@/pages/Promotion/List/List';
import PromotionAdd from '@/pages/Promotion/Add/Add';
import PromotionEdit from '@/pages/Promotion/Edit/Edit';
//Property
import PropertyList from '@/pages/Property/List/List';
import PropertyAdd from '@/pages/Property/Add/Add';
import PropertyEdit from '@/pages/Property/Edit/Edit';
//Purchase Order
import PurchaseOrderList from '@/pages/PurchaseOrder/List/List';
import PurchaseOrderAdd from '@/pages/PurchaseOrder/Add/Add';
import PurchaseOrderEdit from '@/pages/PurchaseOrder/Edit/Edit';
import PurchaseOrderPrint from '@/pages/PurchaseOrder/Print/Print';
import PurchaseOrderView from '@/pages/PurchaseOrder/View/View';
//Purchase Receipt
import PurchaseReceiptList from '@/pages/PurchaseReceipt/List/List';
import PurchaseReceiptAdd from '@/pages/PurchaseReceipt/Add/Add';
import PurchaseReceiptEdit from '@/pages/PurchaseReceipt/Edit/Edit';
import PurchaseReceiptPrint from '@/pages/PurchaseReceipt/Print/Print';
import PurchaseReceiptView from '@/pages/PurchaseReceipt/View/View';
//Region
import RegionList from '@/pages/Region/List/List';
import RegionAdd from '@/pages/Region/Add/Add';
import RegionEdit from '@/pages/Region/Edit/Edit';
//Reimbursements
import ReimbursementAdd from '@/pages/Reimbursement/Add/Add';
import ReimbursementEdit from '@/pages/Reimbursement/Edit/Edit';
import ReimbursementList from '@/pages/Reimbursement/List/List';
import ReimbursementPrint from '@/pages/Reimbursement/Print/Print';
import ReimbursementView from '@/pages/Reimbursement/View/View';
//Request
import RequestList from '@/pages/Request/List/List';
import RequestAdd from '@/pages/Request/Add/Add';
import RequestEdit from '@/pages/Request/Edit/Edit';
import RequestView from '@/pages/Request/View/View';
import RequestPrint from '@/pages/Request/Print/Print';
//Role
import RoleList from '@/pages/Role/List/List';
import RoleAdd from '@/pages/Role/Add/Add';
import RoleEdit from '@/pages/Role/Edit/Edit';
//Route Plan
import RoutePlanList from '@/pages/RoutePlan/List/List';
import RoutePlanAdd from '@/pages/RoutePlan/Add/Add';
import RoutePlanEdit from '@/pages/RoutePlan/Edit/Edit';
import RoutePlanPrint from '@/pages/RoutePlan/Print/Print';
import RoutePlanView from '@/pages/RoutePlan/View/View';
//Sales Channel
import SalesChannelList from '@/pages/SalesChannel/List/List';
import SalesChannelAdd from '@/pages/SalesChannel/Add/Add';
import SalesChannelEdit from '@/pages/SalesChannel/Edit/Edit';
//Sales Order
import SalesOrderList from '@/pages/SalesOrder/List/List';
import SalesOrderAdd from '@/pages/SalesOrder/Add/Add';
import SalesOrderEdit from '@/pages/SalesOrder/Edit/Edit';
import SalesOrderPrint from '@/pages/SalesOrder/Print/Print';
import SalesOrderView from '@/pages/SalesOrder/View/View';
//Sales Order Team
import SalesOrderTeamList from '@/pages/SalesOrder/Team/List/List';
import SalesOrderTeamPrint from '@/pages/SalesOrder/Team/Print/Print';
//SalesRep
import SalesRepList from '@/pages/SalesRep/List/List';
import SalesRepEdit from '@/pages/SalesRep/Edit/Edit';
import SalesRepActivePrint from '@/pages/SalesRep/Print/Active/Print';
import SalesRepRoutePrint from '@/pages/SalesRep/Print/Route/Print';
import SalesRepMapPrint from '@/pages/SalesRep/Print/Map/Print';
//Sales Report
import SalesReportList from '@/pages/SalesReport/List/List';
import SalesReportByCustomer from '@/pages/SalesReport/bycustomer/List';
import SalesReportByItem from '@/pages/SalesReport/byitem/List';
import SalesReportByLocation from '@/pages/SalesReport/bylocation/List';
import SalesReportByTownship from '@/pages/SalesReport/bytownship/List';
import SalesReportByUser from '@/pages/SalesReport/byuser/List';
//Sales Report Team
import SalesReportTeamByItem from '@/pages/SalesReport/team/byitem/List';
//Sales Summary
import SalesSummaryByCustomer from '@/pages/SalesSummary/bycustomer/List';
import SalesSummaryByLocation from '@/pages/SalesSummary/bylocation/List';
import SalesSummaryByUser from '@/pages/SalesSummary/byuser/List';
//Sales Target
import SalesTargetList from '@/pages/SalesTarget/List/List';
import SalesTargetAdd from '@/pages/SalesTarget/Add/Add';
import SalesTargetEdit from '@/pages/SalesTarget/Edit/Edit';
import SalesTargetPrint from '@/pages/SalesTarget/Print/Print';
import SalesTargetView from '@/pages/SalesTarget/View/View';
//System Setting
import SystemSettingList from '@/pages/SystemSetting/List/List';
import SystemSettingAdd from '@/pages/SystemSetting/Add/Add';
import SystemSettingEdit from '@/pages/SystemSetting/Edit/Edit';
//Team
import TeamList from '@/pages/Team/List/List';
import TeamAdd from '@/pages/Team/Add/Add';
import TeamEdit from '@/pages/Team/Edit/Edit';
//Tenant
import TenantList from '@/pages/Tenant/List/List';
import TenantAdd from '@/pages/Tenant/Add/Add';
import TenantEdit from '@/pages/Tenant/Edit/Edit';
import TenantView from '@/pages/Tenant/View/View';
//Township
import TownshipList from '@/pages/Township/List/List';
import TownshipAdd from '@/pages/Township/Add/Add';
import TownshipEdit from '@/pages/Township/Edit/Edit';
//Tour
import TourList from '@/pages/Tour/List/List';
import TourAdd from '@/pages/Tour/Add/Add';
import TourEdit from '@/pages/Tour/Edit/Edit';
//Time Report
import TimeReportList from '@/pages/TimeReport/List/List';
//Time Tracking
import TimeTracking from '@/pages/TimeTracking/TimeTracking';
import TimeTrackingList from '@/pages/TimeTracking/List/List';
import TimeTrackingAdd from '@/pages/TimeTracking/Add/Add';
import TimeTrackingEdit from '@/pages/TimeTracking/Edit/Edit';
//User
import UserList from '@/pages/User/List/List';
import UserAdd from '@/pages/User/Add/Add';
import UserEdit from '@/pages/User/Edit/Edit';
import UserProfile from '@/pages/User/Profile/Profile';
//Vehicle
import VehicleList from '@/pages/Vehicle/List/List';
import VehicleAdd from '@/pages/Vehicle/Add/Add';
import VehicleEdit from '@/pages/Vehicle/Edit/Edit';
//Vendor
import VendorList from '@/pages/Vendor/List/List';
import VendorAdd from '@/pages/Vendor/Add/Add';
import VendorEdit from '@/pages/Vendor/Edit/Edit';
//Visit
import VisitList from '@/pages/Visit/List/List';

import { isAuthenticated } from './mixins/auth';
import { isRoleAccessPathAllowed } from './mixins/role';

Vue.use(Router);

let checkRoleAccessPath = function (to, from, next){
  let str = localStorage.getItem('useraccess');
  let useraccess = JSON.parse(str);
  isRoleAccessPathAllowed(useraccess, to.name, to.path) ? next() : next({ path: '/error' });
};

let checkAuthentication = function (to, from, next){
  let token = localStorage.getItem('token');
  isAuthenticated(token) ? next() : next({ path: '/login' });
};

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/privacy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
    },
    {
      path: '/resetpassword',
      name: 'ResetPassword',
      component: ResetPassword,
    },
    {
      path: '/timetracking',
      name: 'TimeTracking',
      component: TimeTracking,
    },
    {
      path: '/doc/ps/auth/:id?',
      name: 'PayStatementDocAuth',
      component: PayStatementDocAuth,
    },
    {
      path: '/doc/ps/view',
      name: 'PayStatementDocView',
      component: PayStatementDocView,
    },
    {
      name: 'CompanyPolicy',
      path: '/companypolicy',
      redirect: '/companypolicy/view',
      component: CompanyPolicyLayout,
      children: [
        {
          path: '/companypolicy/view',
          name: 'CompanyPolicyView',
          component: CompanyPolicyView,
        },
      ],
    },
    {
      path: '/print/bill/:id',
      name: 'PrintBill',
      component: PrintBill,
      props: true,
    },
    {
      path: '/print/gl-report/is/:id',
      name: 'PrintGLReportIS',
      component: PrintGLReportIS,
      props: true,
    },
    {
      path: '/print/gl-report/bs/:id',
      name: 'PrintGLReportBS',
      component: PrintGLReportBS,
      props: true,
    },
    {
      path: '/print/gl-report/gl/:id',
      name: 'PrintGLReportGL',
      component: PrintGLReportGL,
      props: true,
    },
    {
      path: '/print/invoice/:id',
      name: 'PrintInvoice',
      component: PrintInvoice,
      props: true,
    },
    {
      path: '/print/paystatement/:id',
      name: 'PrintPayStatement',
      component: PrintPayStatement,
      props: true,
    },

    {
      path: '/print/report',
      name: 'PrintReport',
      component: PrintReport,
      props: true,
    },
    {
      path: '/print/salesorder/:id',
      name: 'PrintSalesOrder',
      component: PrintSalesOrder,
      props: true,
    },
    {
      path: '/print/customer/open-invoice/:id',
      name: 'PrintCustomerOpenInvoice',
      component: PrintCustomerOpenInvoice,
      props: true,
    },
    {
      path: '/print/salesrep/open-order/:id',
      name: 'PrintSalesRepOpenOrder',
      component: PrintSalesRepOpenOrder,
      props: true,
    },
    {
      path: '/',
      redirect: 'login',
      name: 'Layout',
      component: Layout,
      beforeEnter: checkAuthentication,
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard,
          //beforeEnter: checkRoleAccessPath,
        }, 
        {
          path: '/chatxc',
          name: 'ChatXC',
          component: ChatXC,
          beforeEnter: checkRoleAccessPath,
        }, 
        {
          path: '/directory',
          name: 'Directory',
          component: Directory,
          beforeEnter: checkRoleAccessPath,
        },        
        {
          path: '/account/list',
          name: 'AccountList',
          component: AccountList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/account/add',
          name: 'AccountAdd',
          component: AccountAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/account/edit',
          name: 'AccountEdit',
          component: AccountEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/alert/list',
          name: 'AlertList',
          component: AlertList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/alert/add',
          name: 'AlertAdd',
          component: AlertAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/alert/edit',
          name: 'AlertEdit',
          component: AlertEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/asset/list',
          name: 'AssetList',
          component: AssetList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/asset/add',
          name: 'AssetAdd',
          component: AssetAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/asset/edit',
          name: 'AssetEdit',
          component: AssetEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/bankaccount/list',
          name: 'BankAccountList',
          component: BankAccountList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/bankaccount/add',
          name: 'BankAccountAdd',
          component: BankAccountAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/bankaccount/edit',
          name: 'BankAccountEdit',
          component: BankAccountEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/bankaccount/view',
          name: 'BankAccountView',
          component: BankAccountView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/batchdeposit/add',
          name: 'BatchDepositAdd',
          component: BatchDepositAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/batchdeposit/edit',
          name: 'BatchDepositEdit',
          component: BatchDepositEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/batchdeposit/list',
          name: 'BatchDepositList',
          component: BatchDepositList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/batchdeposit/print',
          name: 'BatchDepositPrint',
          component: BatchDepositPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/batchpayment/add',
          name: 'BatchPaymentAdd',
          component: BatchPaymentAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/batchpayment/edit',
          name: 'BatchPaymentEdit',
          component: BatchPaymentEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/batchpayment/list',
          name: 'BatchPaymentList',
          component: BatchPaymentList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/batchpayment/print',
          name: 'BatchPaymentPrint',
          component: BatchPaymentPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/bill/list',
          name: 'BillList',
          component: BillList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/bill/add',
          name: 'BillAdd',
          component: BillAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/bill/edit',
          name: 'BillEdit',
          component: BillEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/bill/print',
          name: 'BillPrint',
          component: BillPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/bill/view',
          name: 'BillView',
          component: BillView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/billmaterial/list',
          name: 'BillMaterialList',
          component: BillMaterialList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/billmaterial/add',
          name: 'BillMaterialAdd',
          component: BillMaterialAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/billmaterial/edit',
          name: 'BillMaterialEdit',
          component: BillMaterialEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/billmaterial/print',
          name: 'BillMaterialPrint',
          component: BillMaterialPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/billmaterial/view',
          name: 'BillMaterialView',
          component: BillMaterialView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/brand/list',
          name: 'BrandList',
          component: BrandList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/brand/add',
          name: 'BrandAdd',
          component: BrandAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/brand/edit',
          name: 'BrandEdit',
          component: BrandEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/city/list',
          name: 'CityList',
          component: CityList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/city/add',
          name: 'CityAdd',
          component: CityAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/city/edit',
          name: 'CityEdit',
          component: CityEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/claim/adm/list',
          name: 'ClaimAdmList',
          component: ClaimAdmList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/claim/hrm/list',
          name: 'ClaimHrmList',
          component: ClaimHrmList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/claim/add',
          name: 'ClaimAdd',
          component: ClaimAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/claim/edit',
          name: 'ClaimEdit',
          component: ClaimEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/claim/view',
          name: 'ClaimView',
          component: ClaimView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/claim/print',
          name: 'ClaimPrint',
          component: ClaimPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/company/list',
          name: 'CompanyList',
          component: CompanyList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/company/add',
          name: 'CompanyAdd',
          component: CompanyAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/company/edit',
          name: 'CompanyEdit',
          component: CompanyEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/creativeproject/team/list',
          name: 'CreativeProjectTeamList',
          component: CreativeProjectTeamList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/creativeproject/team/assign',
          name: 'CreativeProjectTeamAssign',
          component: CreativeProjectTeamAssign,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/creativeproject/team/finalize',
          name: 'CreativeProjectTeamFinalize',
          component: CreativeProjectTeamFinalize,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/creativeproject/response',
          name: 'CreativeProjectResponse',
          component: CreativeProjectResponse,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/creativeproject/list',
          name: 'CreativeProjectList',
          component: CreativeProjectList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/creativeproject/edit',
          name: 'CreativeProjectEdit',
          component: CreativeProjectEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/creativeproject/request',
          name: 'CreativeProjectRequest',
          component: CreativeProjectRequest,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/creativeproject/manage',
          name: 'CreativeProjectManage',
          component: CreativeProjectManage,
          beforeEnter: checkRoleAccessPath,
        },        
        {
          path: '/country/list',
          name: 'CountryList',
          component: CountryList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/country/add',
          name: 'CountryAdd',
          component: CountryAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/country/edit',
          name: 'CountryEdit',
          component: CountryEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/currency/list',
          name: 'CurrencyList',
          component: CurrencyList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/currency/add',
          name: 'CurrencyAdd',
          component: CurrencyAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/currency/edit',
          name: 'CurrencyEdit',
          component: CurrencyEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/customer/list',
          name: 'CustomerList',
          component: CustomerList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/customer/active/list',
          name: 'CustomerActiveList',
          component: CustomerActiveList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/customer/add',
          name: 'CustomerAdd',
          component: CustomerAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/customer/edit',
          name: 'CustomerEdit',
          component: CustomerEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/customer/view',
          name: 'CustomerView',
          component: CustomerView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/customerreport/summarybytownship',
          name: 'CustomerReportSummaryByTownship',
          component: CustomerReportSummaryByTownship,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/customerreport/summarybyuser',
          name: 'CustomerReportSummaryByUser',
          component: CustomerReportSummaryByUser,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/department/list',
          name: 'DepartmentList',
          component: DepartmentList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/department/add',
          name: 'DepartmentAdd',
          component: DepartmentAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/department/edit',
          name: 'DepartmentEdit',
          component: DepartmentEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/deposit/add',
          name: 'DepositAdd',
          component: DepositAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/deposit/edit',
          name: 'DepositEdit',
          component: DepositEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/deposit/list',
          name: 'DepositList',
          component: DepositList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/deposit/print',
          name: 'DepositPrint',
          component: DepositPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/deposit/view',
          name: 'DepositView',
          component: DepositView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/district/list',
          name: 'DistrictList',
          component: DistrictList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/district/add',
          name: 'DistrictAdd',
          component: DistrictAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/district/edit',
          name: 'DistrictEdit',
          component: DistrictEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/employee/list',
          name: 'EmployeeList',
          component: EmployeeList,
          beforeEnter: checkRoleAccessPath
        },
        {
          path: '/employee/add',
          name: 'EmployeeAdd',
          component: EmployeeAdd,
          beforeEnter: checkRoleAccessPath
        },
        {
          path: '/employee/edit',
          name: 'EmployeeEdit',
          component: EmployeeEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/employee/card',
          name: 'EmployeeCard',
          component: EmployeeCard,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/employee/view',
          name: 'EmployeeView',
          component: EmployeeView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/employeeface/list',
          name: 'EmployeeFaceList',
          component: EmployeeFaceList,
          beforeEnter: checkRoleAccessPath
        },
        {
          path: '/employeeface/add',
          name: 'EmployeeFaceAdd',
          component: EmployeeFaceAdd,
          beforeEnter: checkRoleAccessPath
        },
        {
          path: '/employeeface/edit',
          name: 'EmployeeFaceEdit',
          component: EmployeeFaceEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/expensereport/byaccount',
          name: 'ExpenseReportByAccount',
          component: ExpenseReportByAccount,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/expensereport/bychannel',
          name: 'ExpenseReportByChannel',
          component: ExpenseReportByChannel,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/expensereport/bylocation',
          name: 'ExpenseReportByLocation',
          component: ExpenseReportByLocation,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/financereport/list',
          name: 'FinanceReportList',
          component: FinanceReportList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/financereport/receivables',
          name: 'FinanceReportReceivables',
          component: FinanceReportReceivables,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/financereport/receivables-aging',
          name: 'FinanceReportReceivablesAging',
          component: FinanceReportReceivablesAging,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/financereport/payables',
          name: 'FinanceReportPayables',
          component: FinanceReportPayables,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/financereport/payables-aging',
          name: 'FinanceReportPayablesAging',
          component: FinanceReportPayablesAging,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/fixedasset/list',
          name: 'FixedAssetList',
          component: FixedAssetList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/fixedasset/add',
          name: 'FixedAssetAdd',
          component: FixedAssetAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/fixedasset/edit',
          name: 'FixedAssetEdit',
          component: FixedAssetEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/fabill/list',
          name: 'FABillList',
          component: FABillList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/fabill/add',
          name: 'FABillAdd',
          component: FABillAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/fabill/edit',
          name: 'FABillEdit',
          component: FABillEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/fabill/print',
          name: 'FABillPrint',
          component: FABillPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/fabill/view',
          name: 'FABillView',
          component: FABillView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/file/preview',
          name: 'FilePreview',
          component: FilePreview,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/geolocation/bycustomer',
          name: 'GeolocationByCustomer',
          component: GeolocationByCustomer,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/geolocation/bycustomersales',
          name: 'GeolocationByCustomerSales',
          component: GeolocationByCustomerSales,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/geolocation/byuser',
          name: 'GeolocationByUser',
          component: GeolocationByUser,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/geolocation/bysalevisits',
          name: 'GeolocationBySaleVisits',
          component: GeolocationBySaleVisits,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-journal/list',
          name: 'GLJournalList',
          component: GLJournalList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-journal/add',
          name: 'GLJournalAdd',
          component: GLJournalAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-journal/edit',
          name: 'GLJournalEdit',
          component: GLJournalEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-journal/print',
          name: 'GLJournalPrint',
          component: GLJournalPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-journal/view',
          name: 'GLJournalView',
          component: GLJournalView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-ledger/list',
          name: 'GLLedgerList',
          component: GLLedgerList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-ledger/add',
          name: 'GLLedgerAdd',
          component: GLLedgerAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-ledger/edit',
          name: 'GLLedgerEdit',
          component: GLLedgerEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-map/list',
          name: 'GLMapList',
          component: GLMapList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-map/add',
          name: 'GLMapAdd',
          component: GLMapAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-map/edit',
          name: 'GLMapEdit',
          component: GLMapEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-post/list',
          name: 'GLPostList',
          component: GLPostList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-post/add',
          name: 'GLPostAdd',
          component: GLPostAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-post/edit',
          name: 'GLPostEdit',
          component: GLPostEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-post/view',
          name: 'GLPostView',
          component: GLPostView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-report/list',
          name: 'GLReportList',
          component: GLReportList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-report/is',
          name: 'GLReportIS',
          component: GLReportIS,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-report/bs',
          name: 'GLReportBS',
          component: GLReportBS,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/gl-report/gl',
          name: 'GLReportGL',
          component: GLReportGL,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/holiday/list',
          name: 'HolidayList',
          component: HolidayList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/holiday/add',
          name: 'HolidayAdd',
          component: HolidayAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/holiday/edit',
          name: 'HolidayEdit',
          component: HolidayEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/inventory/list',
          name: 'InventoryList',
          component: InventoryList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/inventory/print',
          name: 'InventoryPrint',
          component: InventoryPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/inventory/view',
          name: 'InventoryView',
          component: InventoryView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/inventorycount/list',
          name: 'InventoryCountList',
          component: InventoryCountList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/inventorycount/print',
          name: 'InventoryCountPrint',
          component: InventoryCountPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/inventorycount/view',
          name: 'InventoryCountView',
          component: InventoryCountView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/inventoryjournal/list',
          name: 'InventoryJournalList',
          component: InventoryJournalList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/inventoryjournal/add',
          name: 'InventoryJournalAdd',
          component: InventoryJournalAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/inventoryjournal/edit',
          name: 'InventoryJournalEdit',
          component: InventoryJournalEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/inventoryjournal/print',
          name: 'InventoryJournalPrint',
          component: InventoryJournalPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/inventoryjournal/view',
          name: 'InventoryJournalView',
          component: InventoryJournalView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/invoice/list',
          name: 'InvoiceList',
          component: InvoiceList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/invoice/add',
          name: 'InvoiceAdd',
          component: InvoiceAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/invoice/edit',
          name: 'InvoiceEdit',
          component: InvoiceEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/invoice/print',
          name: 'InvoicePrint',
          component: InvoicePrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/invoice/view',
          name: 'InvoiceView',
          component: InvoiceView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/investfund/list',
          name: 'InvestFundList',
          component: InvestFundList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/investfund/add',
          name: 'InvestFundAdd',
          component: InvestFundAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/investfund/edit',
          name: 'InvestFundEdit',
          component: InvestFundEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/investstock/list',
          name: 'InvestStockList',
          component: InvestStockList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/investstock/add',
          name: 'InvestStockAdd',
          component: InvestStockAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/investstock/edit',
          name: 'InvestStockEdit',
          component: InvestStockEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/investjournal/add',
          name: 'InvestJournalAdd',
          component: InvestJournalAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/investjournal/edit',
          name: 'InvestJournalEdit',
          component: InvestJournalEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/investjournal/list',
          name: 'InvestJournalList',
          component: InvestJournalList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/investjournal/print',
          name: 'InvestJournalPrint',
          component: InvestJournalPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/investjournal/view',
          name: 'InvestJournalView',
          component: InvestJournalView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/item/list',
          name: 'ItemList',
          component: ItemList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/item/add',
          name: 'ItemAdd',
          component: ItemAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/item/edit',
          name: 'ItemEdit',
          component: ItemEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/itemcategory/list',
          name: 'ItemCategoryList',
          component: ItemCategoryList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/itemcategory/add',
          name: 'ItemCategoryAdd',
          component: ItemCategoryAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/itemcategory/edit',
          name: 'ItemCategoryEdit',
          component: ItemCategoryEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/itemgroup/list',
          name: 'ItemGroupList',
          component: ItemGroupList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/itemgroup/add',
          name: 'ItemGroupAdd',
          component: ItemGroupAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/itemgroup/edit',
          name: 'ItemGroupEdit',
          component: ItemGroupEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/itemsubcategory/list',
          name: 'ItemSubcategoryList',
          component: ItemSubcategoryList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/itemsubcategory/add',
          name: 'ItemSubcategoryAdd',
          component: ItemSubcategoryAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/itemsubcategory/edit',
          name: 'ItemSubcategoryEdit',
          component: ItemSubcategoryEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/language/list',
          name: 'LanguageList',
          component: LanguageList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/language/add',
          name: 'LanguageAdd',
          component: LanguageAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/language/edit',
          name: 'LanguageEdit',
          component: LanguageEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/loadingorder/list',
          name: 'LoadingOrderList',
          component: LoadingOrderList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/loadingorder/add',
          name: 'LoadingOrderAdd',
          component: LoadingOrderAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/loadingorder/edit',
          name: 'LoadingOrderEdit',
          component: LoadingOrderEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/loadingorder/print',
          name: 'LoadingOrderPrint',
          component: LoadingOrderPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/loadingorder/view',
          name: 'LoadingOrderView',
          component: LoadingOrderView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/location/list',
          name: 'LocationList',
          component: LocationList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/location/add',
          name: 'LocationAdd',
          component: LocationAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/location/edit',
          name: 'LocationEdit',
          component: LocationEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/locationtracking/list',
          name: 'LocationTrackingList',
          component: LocationTrackingList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/locationtracking/add',
          name: 'LocationTrackingAdd',
          component: LocationTrackingAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/locationtracking/edit',
          name: 'LocationTrackingEdit',
          component: LocationTrackingEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/marketplatform/list',
          name: 'MarketPlatformList',
          component: MarketPlatformList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/marketplatform/add',
          name: 'MarketPlatformAdd',
          component: MarketPlatformAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/marketplatform/edit',
          name: 'MarketPlatformEdit',
          component: MarketPlatformEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/marketproject/list',
          name: 'MarketProjectList',
          component: MarketProjectList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/marketproject/team/list',
          name: 'MarketProjectTeamList',
          component: MarketProjectTeamList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/marketproject/add',
          name: 'MarketProjectAdd',
          component: MarketProjectAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/marketproject/edit',
          name: 'MarketProjectEdit',
          component: MarketProjectEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/marketproject/print',
          name: 'MarketProjectPrint',
          component: MarketProjectPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/marketproject/digital/manage',
          name: 'MarketProjectDigitalManage',
          component: MarketProjectDigitalManage,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/marketproject/traditional/manage',
          name: 'MarketProjectTraditionalManage',
          component: MarketProjectTraditionalManage,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/material/list',
          name: 'MaterialList',
          component: MaterialList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/material/add',
          name: 'MaterialAdd',
          component: MaterialAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/material/edit',
          name: 'MaterialEdit',
          component: MaterialEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/menu/list',
          name: 'MenuList',
          component: MenuList,
          //beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/menu/add',
          name: 'MenuAdd',
          component: MenuAdd,
          //beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/menu/edit',
          name: 'MenuEdit',
          component: MenuEdit,
          //beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/my/claim/list',
          name: 'MyClaimList',
          component: MyClaimList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/my/claim/add',
          name: 'MyClaimAdd',
          component: MyClaimAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/my/reimbursement/list',
          name: 'MyReimbursementList',
          component: MyReimbursementList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/my/request/list',
          name: 'MyRequestList',
          component: MyRequestList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/my/request/add',
          name: 'MyRequestAdd',
          component: MyRequestAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/my/statement/list',
          name: 'MyStatementList',
          component: MyStatementList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/my/claim/print',
          name: 'MyClaimPrint',
          component: MyClaimPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payroll/list',
          name: 'PayrollList',
          component: PayrollList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payroll/add',
          name: 'PayrollAdd',
          component: PayrollAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payroll/edit',
          name: 'PayrollEdit',
          component: PayrollEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payroll/print',
          name: 'PayrollPrint',
          component: PayrollPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payroll/view',
          name: 'PayrollView',
          component: PayrollView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payrollentry/list',
          name: 'PayrollEntryList',
          component: PayrollEntryList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payrollentry/add',
          name: 'PayrollEntryAdd',
          component: PayrollEntryAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payrollentry/edit',
          name: 'PayrollEntryEdit',
          component: PayrollEntryEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payrollrecurring/list',
          name: 'PayrollRecurringList',
          component: PayrollRecurringList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payrollrecurring/add',
          name: 'PayrollRecurringAdd',
          component: PayrollRecurringAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payrollrecurring/edit',
          name: 'PayrollRecurringEdit',
          component: PayrollRecurringEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payment/add',
          name: 'PaymentAdd',
          component: PaymentAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payment/edit',
          name: 'PaymentEdit',
          component: PaymentEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payment/list',
          name: 'PaymentList',
          component: PaymentList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payment/print',
          name: 'PaymentPrint',
          component: PaymentPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/payment/view',
          name: 'PaymentView',
          component: PaymentView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/paymethod/list',
          name: 'PayMethodList',
          component: PayMethodList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/paymethod/add',
          name: 'PayMethodAdd',
          component: PayMethodAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/paymethod/edit',
          name: 'PayMethodEdit',
          component: PayMethodEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/paystatement/list',
          name: 'PayStatementList',
          component: PayStatementList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/paystatement/add',
          name: 'PayStatementAdd',
          component: PayStatementAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/paystatement/edit',
          name: 'PayStatementEdit',
          component: PayStatementEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/paystatement/print',
          name: 'PayStatementPrint',
          component: PayStatementPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/policy/list',
          name: 'PolicyList',
          component: PolicyList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/policy/add',
          name: 'PolicyAdd',
          component: PolicyAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/policy/edit',
          name: 'PolicyEdit',
          component: PolicyEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/policy/print',
          name: 'PolicyPrint',
          component: PolicyPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/price/list',
          name: 'PriceList',
          component: PriceList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/price/add',
          name: 'PriceAdd',
          component: PriceAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/price/edit',
          name: 'PriceEdit',
          component: PriceEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/pricelist/list',
          name: 'PricelistList',
          component: PricelistList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/pricelist/add',
          name: 'PricelistAdd',
          component: PricelistAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/pricelist/edit',
          name: 'PricelistEdit',
          component: PricelistEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/pricelist/print',
          name: 'PricelistPrint',
          component: PricelistPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/promotion/list',
          name: 'PromotionList',
          component: PromotionList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/promotion/add',
          name: 'PromotionAdd',
          component: PromotionAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/promotion/edit',
          name: 'PromotionEdit',
          component: PromotionEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/property/list',
          name: 'PropertyList',
          component: PropertyList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/property/add',
          name: 'PropertyAdd',
          component: PropertyAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/property/edit',
          name: 'PropertyEdit',
          component: PropertyEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/purchaseorder/list',
          name: 'PurchaseOrderList',
          component: PurchaseOrderList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/purchaseorder/add',
          name: 'PurchaseOrderAdd',
          component: PurchaseOrderAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/purchaseorder/edit',
          name: 'PurchaseOrderEdit',
          component: PurchaseOrderEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/purchaseorder/print',
          name: 'PurchaseOrderPrint',
          component: PurchaseOrderPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/purchaseorder/view',
          name: 'PurchaseOrderView',
          component: PurchaseOrderView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/purchasereceipt/list',
          name: 'PurchaseReceiptList',
          component: PurchaseReceiptList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/purchasereceipt/add',
          name: 'PurchaseReceiptAdd',
          component: PurchaseReceiptAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/purchasereceipt/edit',
          name: 'PurchaseReceiptEdit',
          component: PurchaseReceiptEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/purchasereceipt/print',
          name: 'PurchaseReceiptPrint',
          component: PurchaseReceiptPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/purchasereceipt/view',
          name: 'PurchaseReceiptView',
          component: PurchaseReceiptView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/reimbursement/add',
          name: 'ReimbursementAdd',
          component: ReimbursementAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/reimbursement/edit',
          name: 'ReimbursementEdit',
          component: ReimbursementEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/reimbursement/list',
          name: 'ReimbursementList',
          component: ReimbursementList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/reimbursement/view',
          name: 'ReimbursementView',
          component: ReimbursementView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/reimbursement/print',
          name: 'ReimbursementPrint',
          component: ReimbursementPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/region/list',
          name: 'RegionList',
          component: RegionList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/region/add',
          name: 'RegionAdd',
          component: RegionAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/region/edit',
          name: 'RegionEdit',
          component: RegionEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/request/list',
          name: 'RequestList',
          component: RequestList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/request/add',
          name: 'RequestAdd',
          component: RequestAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/request/edit',
          name: 'RequestEdit',
          component: RequestEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/request/view',
          name: 'RequestView',
          component: RequestView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/request/print',
          name: 'RequestPrint',
          component: RequestPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/role/list',
          name: 'RoleList',
          component: RoleList,
          //beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/role/add',
          name: 'RoleAdd',
          component: RoleAdd,
          //beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/role/edit',
          name: 'RoleEdit',
          component: RoleEdit,
          //beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/routeplan/list',
          name: 'RoutePlanList',
          component: RoutePlanList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/routeplan/add',
          name: 'RoutePlanAdd',
          component: RoutePlanAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/routeplan/edit',
          name: 'RoutePlanEdit',
          component: RoutePlanEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/routeplan/print',
          name: 'RoutePlanPrint',
          component: RoutePlanPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/routeplan/view',
          name: 'RoutePlanView',
          component: RoutePlanView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/saleschannel/list',
          name: 'SalesChannelList',
          component: SalesChannelList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/saleschannel/add',
          name: 'SalesChannelAdd',
          component: SalesChannelAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/saleschannel/edit',
          name: 'SalesChannelEdit',
          component: SalesChannelEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesorder/list',
          name: 'SalesOrderList',
          component: SalesOrderList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesorder/add',
          name: 'SalesOrderAdd',
          component: SalesOrderAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesorder/edit',
          name: 'SalesOrderEdit',
          component: SalesOrderEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesorder/print',
          name: 'SalesOrderPrint',
          component: SalesOrderPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesorder/view',
          name: 'SalesOrderView',
          component: SalesOrderView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesorder/team/list',
          name: 'SalesOrderTeamList',
          component: SalesOrderTeamList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesorder/team/print',
          name: 'SalesOrderTeamPrint',
          component: SalesOrderTeamPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesrep/list',
          name: 'SalesRepList',
          component: SalesRepList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesrep/edit',
          name: 'SalesRepEdit',
          component: SalesRepEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesrep/route/print',
          name: 'SalesRepRoutePrint',
          component: SalesRepRoutePrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesrep/active/print',
          name: 'SalesRepActivePrint',
          component: SalesRepActivePrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesrep/map/print',
          name: 'SalesRepMapPrint',
          component: SalesRepMapPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesreport/list',
          name: 'SalesReportList',
          component: SalesReportList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesreport/byitem',
          name: 'SalesReportByItem',
          component: SalesReportByItem,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesreport/bycustomer',
          name: 'SalesReportByCustomer',
          component: SalesReportByCustomer,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesreport/bylocation',
          name: 'SalesReportByLocation',
          component: SalesReportByLocation,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesreport/bytownship',
          name: 'SalesReportByTownship',
          component: SalesReportByTownship,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesreport/byuser',
          name: 'SalesReportByUser',
          component: SalesReportByUser,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salesreport/team/byitem',
          name: 'SalesReportTeamByItem',
          component: SalesReportTeamByItem,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salessummary/bycustomer',
          name: 'SalesSummaryByCustomer',
          component: SalesSummaryByCustomer,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salessummary/bylocation',
          name: 'SalesSummaryByLocation',
          component: SalesSummaryByLocation,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salessummary/byuser',
          name: 'SalesSummaryByUser',
          component: SalesSummaryByUser,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salestarget/list',
          name: 'SalesTargetList',
          component: SalesTargetList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salestarget/add',
          name: 'SalesTargetAdd',
          component: SalesTargetAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salestarget/edit',
          name: 'SalesTargetEdit',
          component: SalesTargetEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salestarget/print',
          name: 'SalesTargetPrint',
          component: SalesTargetPrint,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/salestarget/view',
          name: 'SalesTargetView',
          component: SalesTargetView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/systemsetting/list',
          name: 'SystemSettingList',
          component: SystemSettingList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/systemsetting/add',
          name: 'SystemSettingAdd',
          component: SystemSettingAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/systemsetting/edit',
          name: 'SystemSettingEdit',
          component: SystemSettingEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/team/list',
          name: 'TeamList',
          component: TeamList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/team/add',
          name: 'TeamAdd',
          component: TeamAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/team/edit',
          name: 'TeamEdit',
          component: TeamEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/tenant/list',
          name: 'TenantList',
          component: TenantList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/tenant/add',
          name: 'TenantAdd',
          component: TenantAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/tenant/edit',
          name: 'TenantEdit',
          component: TenantEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/tenant/view',
          name: 'TenantView',
          component: TenantView,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/township/list',
          name: 'TownshipList',
          component: TownshipList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/township/add',
          name: 'TownshipAdd',
          component: TownshipAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/township/edit',
          name: 'TownshipEdit',
          component: TownshipEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/tour/list',
          name: 'TourList',
          component: TourList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/tour/add',
          name: 'TourAdd',
          component: TourAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/tour/edit',
          name: 'TourEdit',
          component: TourEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/timereport/list',
          name: 'TimeReportList',
          component: TimeReportList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/timetracking/list',
          name: 'TimeTrackingList',
          component: TimeTrackingList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/timetracking/add',
          name: 'TimeTrackingAdd',
          component: TimeTrackingAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/timetracking/edit',
          name: 'TimeTrackingEdit',
          component: TimeTrackingEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/user/list',
          name: 'UserList',
          component: UserList,
          //beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/user/add',
          name: 'UserAdd',
          component: UserAdd,
          //beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/user/edit',
          name: 'UserEdit',
          component: UserEdit,
          //beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/user/profile',
          name: 'UserProfile',
          component: UserProfile,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/vehicle/list',
          name: 'VehicleList',
          component: VehicleList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/vehicle/add',
          name: 'VehicleAdd',
          component: VehicleAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/vehicle/edit',
          name: 'VehicleEdit',
          component: VehicleEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/vendor/list',
          name: 'VendorList',
          component: VendorList,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/vendor/add',
          name: 'VendorAdd',
          component: VendorAdd,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/vendor/edit',
          name: 'VendorEdit',
          component: VendorEdit,
          beforeEnter: checkRoleAccessPath,
        },
        {
          path: '/visit/list',
          name: 'VisitList',
          component: VisitList,
          beforeEnter: checkRoleAccessPath,
        },
      ],
    },
    {
      path: '*',
      name: 'Error',
      component: Error,
    },
  ],
});
